/**
 * `cloudgrid --version` rendering. Plain mode prints just the version;
 * `--version --verbose` adds Node + OS + telemetry status.
 *
 * Decision 016 §"Privacy and anonymization" requires the default-on
 * telemetry to be visible on three surfaces: the README, the `cloudgrid
 * login` first-run notice, and `cloudgrid --version --verbose`. This
 * module owns the third surface.
 */

import { isTelemetryEnabled } from './services/telemetry.js';

export interface VersionInfo {
  version: string;
  nodeVersion: string;
  os: string;
  telemetryEnabled: boolean;
}

export function getVersionInfo(version: string): VersionInfo {
  return {
    version,
    nodeVersion: process.version,
    os: `${process.platform} ${process.arch}`,
    telemetryEnabled: isTelemetryEnabled(),
  };
}

export function formatVersion(info: VersionInfo, verbose: boolean): string {
  if (!verbose) return `${info.version}\n`;
  const lines = [
    `cloudgrid ${info.version}`,
    `  Node ${info.nodeVersion}`,
    `  ${info.os}`,
    '',
  ];
  if (info.telemetryEnabled) {
    lines.push(
      'Telemetry: enabled (default in pre-release).',
      '  Disable with CLOUDGRID_TELEMETRY=0 or `cloudgrid login --no-telemetry`.',
      "  See: docs/decisions/016 for what's collected.",
    );
  } else {
    lines.push('Telemetry: disabled.');
  }
  return lines.join('\n') + '\n';
}
